import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IPartnerUser, PartnerUser } from "@/models/user.entity";

export const PartnerUserAccessLayer = new (class extends AbstractLocalDataAccessLayer<IPartnerUser, "mail"> {
  getIdentifier(entity: IPartnerUser): string {
    return entity.id;
  }

  protected mapEntity(entity: IPartnerUser): IPartnerUser {
    return new PartnerUser(entity);
  }

  /**
   * Every lowercased mail address a user can be reached at, so the sender of a received message can
   * be matched back to the user that wrote it. Look the key up with `mailAddress(readable)`.
   */
  mapsConfig = {
    mail: {
      getIdentifier: (entity: IPartnerUser) => [
        ...new Set(
          [entity.userName, entity.contact?.email]
            .filter((mail): mail is string => !!mail)
            .map((mail) => mail.toLowerCase())
        )
      ]
    }
  };
})();
